<template>
  <v-row class="mx-5 px-5">
    <v-col>
      <!-- Placeholder Image -->
      <v-img src="@/shared/assets/check_email.png" max-height="5rem" class="my-5" />
      <v-card-title class="text-center text-h4 mb-1 text-grey-darken-3">
        {{ $t("common.checkEmail") }}
      </v-card-title>
      <v-row class="justify-center mb-1">
        <v-card-text class="text-body-1 text-center text-grey-darken-2">
          {{ $t("page.resetPassword.recoverPasswordNote") }}
        </v-card-text>
      </v-row>
      <v-card-text class="text-body-3 text-center text-grey-darken-1">
        {{ $t("page.resetPassword.checkSpam") }}
      </v-card-text>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup></script>
